import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme } from '@lingaai/shared-theme';
import { useUIStore } from '../stores/useUIStore';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const themeMode = useUIStore((state) => state.themeMode);
  const theme = themeMode === 'light' ? lightTheme : darkTheme;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
